export default __webpack_public_path__ + "static/media/footerbg.f40c3471.jpg";